module.exports = __webpack_public_path__ + "img/nyj_bg.00d2bf6e.png";